import {InputTypes} from "../InputTypes";

export const Article = Object.freeze({
    name: {
        visibleName: "Título",
        type: InputTypes.TEXT
    },
    visible_timestamp: {
        visibleName: "Visible después",
        type: InputTypes.DATE,
    },
    timestamp:{
        visibleName: "Fecha de Creación",
        type: InputTypes.DATE,
        readOnly: true
    },
    text:{
        visibleName: "Descripción",
        type: InputTypes.RICH_TEXT_AREA
    },
    user_name:{
        visibleName: "Creador",
        type: InputTypes.TEXT
    },
    media:{
        visibleName: "Media",
        type: InputTypes.PREVIEW
    },
})